webpackJsonp([231625713469023],{

/***/ 241:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    grid-column-gap: 0.5rem;\n    grid-template-areas:\n      \'fs fs fs fs fs fs fs fs fs fs fs fs\'\n      \'filt filt filt filt lst lst lst lst lst lst lst .\';\n  '], ['\n    grid-column-gap: 0.5rem;\n    grid-template-areas:\n      \'fs fs fs fs fs fs fs fs fs fs fs fs\'\n      \'filt filt filt filt lst lst lst lst lst lst lst .\';\n  ']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n    grid-column-gap: 0.5rem;\n    grid-template-areas:\n      \'fs fs fs fs fs fs fs fs fs fs fs fs\'\n      \'filt filt filt filt filt filt filt filt filt filt filt filt\'\n      \'. lst lst lst lst lst lst lst lst lst lst .\';\n  '], ['\n    grid-column-gap: 0.5rem;\n    grid-template-areas:\n      \'fs fs fs fs fs fs fs fs fs fs fs fs\'\n      \'filt filt filt filt filt filt filt filt filt filt filt filt\'\n      \'. lst lst lst lst lst lst lst lst lst lst .\';\n  ']);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _globalStyle = __webpack_require__(6);
	
	var _JobsFilter = __webpack_require__(242);
	
	var _JobsFilter2 = _interopRequireDefault(_JobsFilter);
	
	var _JobsList = __webpack_require__(96);
	
	var _JobsList2 = _interopRequireDefault(_JobsList);
	
	var _Pagination = __webpack_require__(54);
	
	var _Pagination2 = _interopRequireDefault(_Pagination);
	
	var _FilterAndSearch = __webpack_require__(35);
	
	var _FilterAndSearch2 = _interopRequireDefault(_FilterAndSearch);
	
	var _Titles = __webpack_require__(38);
	
	var _api = __webpack_require__(73);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Wrapper = _styledComponents2.default.div.withConfig({
	  displayName: 'JobsContainer__Wrapper'
	})(['display:grid;grid-template-columns:repeat(12,1fr);grid-template-rows:auto;grid-column-gap:1rem;grid-template-areas:\'. fs fs fs fs fs fs fs fs fs fs .\' \'. filt filt filt lst lst lst lst lst lst lst .\';margin-top:2.5rem;', ' ', ';'], _globalStyle.media.tablet(_templateObject), _globalStyle.media.phone(_templateObject2));
	
	var List = _styledComponents2.default.div.withConfig({
	  displayName: 'JobsContainer__List'
	})(['grid-area:lst;display:flex;flex-direction:column;align-items:stretch;margin:0;padding:0;']);
	
	var JobsContainer = function (_React$Component) {
	  _inherits(JobsContainer, _React$Component);
	
	  function JobsContainer(props) {
	    _classCallCheck(this, JobsContainer);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      loading: true,
	      searchQuery: '',
	      filter: ['any', 'any', 'any', 'any'],
	      query: [{
	        title: '',
	        type: '',
	        role: '',
	        location: '',
	        description: ''
	      }]
	    };
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.submitQuery = _this.submitQuery.bind(_this);
	    _this.changePage = _this.changePage.bind(_this);
	    _this.handleDates = _this.handleDates.bind(_this);
	    _this.handleSearch = _this.handleSearch.bind(_this);
	    _this.handleInput = _this.handleInput.bind(_this);
	    return _this;
	  }
	
	  JobsContainer.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    var loading = false;
	    (0, _api.fakeAPI)().then(function (query) {
	      return _this2.setState({ loading: loading, query: query });
	    });
	  };
	
	  JobsContainer.prototype.handleChange = function handleChange(num, data) {
	    var arr = this.state.filter.slice();
	    arr[num - 1] = data;
	
	    this.setState({
	      filter: arr
	    });
	  };
	
	  JobsContainer.prototype.submitQuery = function submitQuery() {
	    var _this3 = this;
	
	    var data = this.state.filter;
	    (0, _api.fakeAPI)(10, data).then(function (query) {
	      return _this3.setState({ query: query });
	    });
	  };
	
	  JobsContainer.prototype.changePage = function changePage(num) {
	    var _this4 = this;
	
	    //for now it immitates querying different pages
	    var fakePage = function fakePage() {
	      var result;
	      if (_this4.state.searchQuery) {
	        var searchQuery = _this4.state.searchQuery;
	        result = (0, _api.fakeAPI)(undefined, undefined, searchQuery);
	      } else {
	        result = (0, _api.fakeAPI)();
	      }
	      result.then(function (query) {
	        return _this4.setState({ query: query });
	      });
	    };
	
	    if (num === -1) {
	      //get previous page
	      fakePage();
	    } else if (num === 0) {
	      // get next page
	      fakePage();
	    } else {
	      //get page #num
	      fakePage();
	    }
	  };
	
	  JobsContainer.prototype.handleDates = function handleDates(str) {
	    var _this5 = this;
	
	    // immitation of new query
	    var data = this.state.filter;
	    var currLength = this.state.query.length < 5 ? 7 : this.state.query.length,
	        length = str === 'all' ? 7 : Math.floor(Math.random() * (currLength + 1));
	    var result;
	
	    if (this.state.searchQuery) {
	      var searchQuery = this.state.searchQuery;
	      result = (0, _api.fakeAPI)(length, undefined, searchQuery);
	    } else {
	      result = (0, _api.fakeAPI)(length, data);
	    }
	
	    result.then(function (query) {
	      return _this5.setState({ query: query });
	    });
	  };
	
	  JobsContainer.prototype.handleSearch = function handleSearch() {
	    var _this6 = this;
	
	    //immitation of search query
	    if (this.state.searchQuery) {
	      var searchStr = this.state.searchQuery;
	      (0, _api.fakeAPISearch)(searchStr).then(function (query) {
	        return _this6.setState({ query: query });
	      });
	    }
	  };
	
	  JobsContainer.prototype.handleInput = function handleInput(val) {
	    this.setState({
	      searchQuery: val
	    });
	  };
	
	  JobsContainer.prototype.render = function render() {
	    var arr = [].concat(this.state.query);
	    var loading = this.state.loading;
	    return _react2.default.createElement(
	      Wrapper,
	      null,
	      _react2.default.createElement(_FilterAndSearch2.default, {
	        area: 'fs',
	        items: this.props.menuFilter,
	        changeDates: this.handleDates,
	        search: this.handleSearch,
	        input: this.handleInput
	      }),
	      _react2.default.createElement(_JobsFilter2.default, {
	        titles: this.state.filter,
	        onChange: this.handleChange,
	        onSubmit: this.submitQuery
	      }),
	      loading ? _react2.default.createElement(
	        _Titles.LoadingContent,
	        { area: 'lst' },
	        'Loading...'
	      ) : _react2.default.createElement(
	        List,
	        null,
	        arr.map(function (elem, index) {
	          return _react2.default.createElement(_JobsList2.default, {
	            key: index,
	            area: 'lst',
	            title: elem.title,
	            text: elem
	          });
	        }),
	        _react2.default.createElement(_Pagination2.default, {
	          onChange: this.changePage,
	          background: this.props.theme.white,
	          pageNum: 2
	        })
	      )
	    );
	  };
	
	  return JobsContainer;
	}(_react2.default.Component);
	
	exports.default = (0, _styledComponents.withTheme)(JobsContainer);
	
	
	JobsContainer.propTypes = {
	  menuFilter: _propTypes2.default.array.isRequired,
	  theme: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.object])
	};
	module.exports = exports['default'];

/***/ }),

/***/ 242:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    flex-flow: row wrap;\n    align-items: flex-end;\n    padding: 0.25rem;\n    margin-bottom: 0.6rem;\n    justify-content: space-around;\n  '], ['\n    flex-flow: row wrap;\n    align-items: flex-end;\n    padding: 0.25rem;\n    margin-bottom: 0.6rem;\n    justify-content: space-around;\n  ']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n    padding: 0.2rem;\n  '], ['\n    padding: 0.2rem;\n  ']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  text-transform: uppercase;\n  font-size: 1.2rem;\n  color: ', ';\n  margin: 0.5rem;\n  padding: 0.5rem;\n  ', ' ', ' ', ';\n'], ['\n  text-transform: uppercase;\n  font-size: 1.2rem;\n  color: ', ';\n  margin: 0.5rem;\n  padding: 0.5rem;\n  ', ' ', ' ', ';\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n    font-size: 1rem;\n    padding: 0;\n    margin: 0.3rem 0;\n  '], ['\n    font-size: 1rem;\n    padding: 0;\n    margin: 0.3rem 0;\n  ']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n    padding: 0.3rem 0;\n  '], ['\n    padding: 0.3rem 0;\n  ']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n    text-align: center;\n    font-size: 0.8rem;\n  '], ['\n    text-align: center;\n    font-size: 0.8rem;\n  ']),
	    _templateObject7 = _taggedTemplateLiteralLoose(['\n    min-width: 10rem;\n    padding: 0.7rem;\n    font-size: 1.2rem;\n    svg {\n      width: 1.2rem;\n      height: 1.2rem;\n    }\n  '], ['\n    min-width: 10rem;\n    padding: 0.7rem;\n    font-size: 1.2rem;\n    svg {\n      width: 1.2rem;\n      height: 1.2rem;\n    }\n  ']),
	    _templateObject8 = _taggedTemplateLiteralLoose(['\n    min-width: 9rem;\n    font-size: 1rem;\n    padding: 0.8rem;\n  '], ['\n    min-width: 9rem;\n    font-size: 1rem;\n    padding: 0.8rem;\n  ']),
	    _templateObject9 = _taggedTemplateLiteralLoose(['\n    min-width: 8.5rem;\n  '], ['\n    min-width: 8.5rem;\n  ']),
	    _templateObject10 = _taggedTemplateLiteralLoose(['\n    min-width: 9rem;\n    font-size: 1rem;\n    text-transform: lowercase;\n    flex: 1 0 80px;\n    svg {\n      width: 1rem;\n      height: 1rem;\n    }\n  '], ['\n    min-width: 9rem;\n    font-size: 1rem;\n    text-transform: lowercase;\n    flex: 1 0 80px;\n    svg {\n      width: 1rem;\n      height: 1rem;\n    }\n  ']),
	    _templateObject11 = _taggedTemplateLiteralLoose(['\n    min-width: 10rem;\n  '], ['\n    min-width: 10rem;\n  ']),
	    _templateObject12 = _taggedTemplateLiteralLoose(['\n    min-width: 9rem;\n  '], ['\n    min-width: 9rem;\n  ']),
	    _templateObject13 = _taggedTemplateLiteralLoose(['\n  padding: 12px 16px;\n  margin: 0;\n  display: block;\n  font-size: 1.1rem;\n  color: ', ';\n  &:visited,\n  &:active {\n    color: inherit;\n  }\n  &:hover {\n    color: ', ';\n    background-color: ', ';\n  }\n  ', ' ', ' ', ';\n'], ['\n  padding: 12px 16px;\n  margin: 0;\n  display: block;\n  font-size: 1.1rem;\n  color: ', ';\n  &:visited,\n  &:active {\n    color: inherit;\n  }\n  &:hover {\n    color: ', ';\n    background-color: ', ';\n  }\n  ', ' ', ' ', ';\n']),
	    _templateObject14 = _taggedTemplateLiteralLoose(['\n    padding: 0.5rem 0.2rem;\n    font-size: 1.15rem;\n  '], ['\n    padding: 0.5rem 0.2rem;\n    font-size: 1.15rem;\n  ']),
	    _templateObject15 = _taggedTemplateLiteralLoose(['\n    padding: 0.5rem 0.6rem;\n    font-size: 1rem;\n  '], ['\n    padding: 0.5rem 0.6rem;\n    font-size: 1rem;\n  ']),
	    _templateObject16 = _taggedTemplateLiteralLoose(['\n    font-size: 1rem;\n    padding: 0.4rem 0.6rem;\n    text-transform: lowercase;\n  '], ['\n    font-size: 1rem;\n    padding: 0.4rem 0.6rem;\n    text-transform: lowercase;\n  ']),
	    _templateObject17 = _taggedTemplateLiteralLoose(['\n  display: block;\n  min-width: 10rem;\n  padding: 1rem;\n  font-size: 1.4rem;\n  font-weight: 600;\n  border-width: 2px;\n  margin: 3rem 0 0 0;\n  ', ' ', ' ', ' ', ';\n'], ['\n  display: block;\n  min-width: 10rem;\n  padding: 1rem;\n  font-size: 1.4rem;\n  font-weight: 600;\n  border-width: 2px;\n  margin: 3rem 0 0 0;\n  ', ' ', ' ', ' ', ';\n']),
	    _templateObject18 = _taggedTemplateLiteralLoose(['\n    min-width: 8rem;\n    padding: 0.5rem;\n    font-size: 1.2rem;\n    margin-top: 2.5rem;\n  '], ['\n    min-width: 8rem;\n    padding: 0.5rem;\n    font-size: 1.2rem;\n    margin-top: 2.5rem;\n  ']),
	    _templateObject19 = _taggedTemplateLiteralLoose(['\n    min-width: 7rem;\n    padding: 0.5rem;\n    font-size: 1.2rem;\n    margin: 2rem 0 0 0;\n  '], ['\n    min-width: 7rem;\n    padding: 0.5rem;\n    font-size: 1.2rem;\n    margin: 2rem 0 0 0;\n  ']),
	    _templateObject20 = _taggedTemplateLiteralLoose(['\n    min-width: 6.5rem;\n  '], ['\n    min-width: 6.5rem;\n  ']),
	    _templateObject21 = _taggedTemplateLiteralLoose(['\n    min-width: 10rem;\n    font-size: 0.9rem;\n    margin: 0.9rem 0;\n  '], ['\n    min-width: 10rem;\n    font-size: 0.9rem;\n    margin: 0.9rem 0;\n  ']);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _globalStyle = __webpack_require__(6);
	
	var _Button = __webpack_require__(72);
	
	var _Icon = __webpack_require__(36);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _constants = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var FilterContainer = _styledComponents2.default.div.withConfig({
	  displayName: 'JobsFilter__FilterContainer'
	})(['grid-area:filt;display:flex;flex-direction:column;align-items:center;margin-top:0.1rem;margin-bottom:11rem;', ';'], _globalStyle.media.phone(_templateObject));
	
	var StyledFilter = _styledComponents2.default.div.withConfig({
	  displayName: 'JobsFilter__StyledFilter'
	})(['position:relative;margin-bottom:0.5rem;padding:0.5rem;', ';'], _globalStyle.media.phone(_templateObject2));
	
	var FilterTitle = _globalStyle.StyledH3.extend(_templateObject3, function (props) {
	  return props.theme.primary.light;
	}, _globalStyle.media.giant(_templateObject4), _globalStyle.media.desktop(_templateObject5), _globalStyle.media.phone(_templateObject6));
	
	var FilterName = _styledComponents2.default.button.withConfig({
	  displayName: 'JobsFilter__FilterName'
	})(['min-width:12rem;padding:1rem;font-size:1.2rem;background-color:', ';color:', ';border:none;border-radius:2px;display:flex;justify-content:space-between;&:hover,&:focus{background-color:', ';}', ' ', ' ', ' ', ';'], function (props) {
	  return props.theme.primary.light;
	}, function (props) {
	  return props.theme.white;
	}, function (props) {
	  return props.theme.secondary.red;
	}, _globalStyle.media.giant(_templateObject7), _globalStyle.media.desktop(_templateObject8), _globalStyle.media.tablet(_templateObject9), _globalStyle.media.phone(_templateObject10));
	
	var OptionContainer = _styledComponents2.default.div.withConfig({
	  displayName: 'JobsFilter__OptionContainer'
	})(['display:none;position:absolute;background-color:', ';border-radius:2px;min-width:12rem;box-shadow:0px 8px 16px 0px rgba(0,0,0,0.2);z-index:1;&.show{display:block;}', ' ', ' ', ' ', ';'], function (props) {
	  return props.theme.white;
	}, _globalStyle.media.giant(_templateObject11), _globalStyle.media.desktop(_templateObject12), _globalStyle.media.tablet(_templateObject9), _globalStyle.media.phone(_templateObject12));
	
	var FilterOption = _globalStyle.StyledA.extend(_templateObject13, function (props) {
	  return props.theme.primary.dark;
	}, function (props) {
	  return props.theme.white;
	}, function (props) {
	  return props.theme.primary.light;
	}, _globalStyle.media.desktop(_templateObject14), _globalStyle.media.desktop(_templateObject15), _globalStyle.media.phone(_templateObject16));
	var SubmitButton = _Button.Button.extend(_templateObject17, _globalStyle.media.giant(_templateObject18), _globalStyle.media.desktop(_templateObject19), _globalStyle.media.tablet(_templateObject20), _globalStyle.media.phone(_templateObject21));
	
	var JobsFilter = function (_React$Component) {
	  _inherits(JobsFilter, _React$Component);
	
	  function JobsFilter(props) {
	    _classCallCheck(this, JobsFilter);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    _this.handleOption = _this.handleOption.bind(_this);
	    _this.handleMouseLeave = _this.handleMouseLeave.bind(_this);
	    _this.handleSubmit = _this.handleSubmit.bind(_this);
	    return _this;
	  }
	
	  // events on FilterName
	
	
	  JobsFilter.prototype.handleClick = function handleClick(e) {
	    var targetId = e.currentTarget.id,
	        currOptionId = 'opt-cont-' + targetId.substr(-1),
	        currOption = document.getElementById(currOptionId);
	    currOption.classList.toggle('show');
	  };
	
	  // events on OptionContainer
	
	
	  JobsFilter.prototype.handleOption = function handleOption(e) {
	    var targetId = e.target.parentNode.id,
	        num = targetId.substr(-1),
	        targetParent = e.target.parentNode,
	        targetText = e.target.innerText,
	        currFilterId = 'filter' + num,
	        currFilter = document.getElementById(currFilterId);
	    currFilter.firstChild.innerHTML = targetText;
	    targetParent.classList.remove('show');
	
	    this.props.onChange(num, targetText.toLowerCase());
	  };
	
	  JobsFilter.prototype.handleMouseLeave = function handleMouseLeave(e) {
	    var targetParent = e.target.parentNode;
	    targetParent.classList.remove('show');
	  };
	
	  JobsFilter.prototype.handleSubmit = function handleSubmit() {
	    this.props.onSubmit();
	  };
	
	  JobsFilter.prototype.render = function render() {
	    return _react2.default.createElement(
	      FilterContainer,
	      null,
	      _react2.default.createElement(
	        StyledFilter,
	        null,
	        _react2.default.createElement(
	          FilterTitle,
	          null,
	          'jobs type'
	        ),
	        _react2.default.createElement(
	          FilterName,
	          { id: 'filter1', onClick: this.handleClick },
	          _react2.default.createElement(
	            'span',
	            null,
	            this.props.titles[0]
	          ),
	          _react2.default.createElement(_Icon2.default, {
	            icon: _constants.ICONS.CIRCLEDOWN,
	            size: 24,
	            color: function color(_ref) {
	              var theme = _ref.theme;
	              return theme.white;
	            }
	          })
	        ),
	        _react2.default.createElement(
	          OptionContainer,
	          {
	            id: 'opt-cont-1',
	            onMouseLeave: this.handleMouseLeave },
	          _react2.default.createElement(
	            FilterOption,
	            { onClick: this.handleOption },
	            'any'
	          ),
	          _react2.default.createElement(
	            FilterOption,
	            { onClick: this.handleOption },
	            'full-time'
	          ),
	          _react2.default.createElement(
	            FilterOption,
	            { onClick: this.handleOption },
	            'part-time'
	          ),
	          _react2.default.createElement(
	            FilterOption,
	            { onClick: this.handleOption },
	            'remote'
	          ),
	          _react2.default.createElement(
	            FilterOption,
	            { onClick: this.handleOption },
	            'internship'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        StyledFilter,
	        null,
	        _react2.default.createElement(
	          FilterTitle,
	          null,
	          'jobs role'
	        ),
	        _react2.default.createElement(
	          FilterName,
	          { id: 'filter2', onClick: this.handleClick },
	          _react2.default.createElement(
	            'span',
	            null,
	            this.props.titles[1]
	          ),
	          _react2.default.createElement(_Icon2.default, {
	            icon: _constants.ICONS.CIRCLEDOWN,
	            size: 24,
	            color: function color(_ref2) {
	              var theme = _ref2.theme;
	              return theme.white;
	            }
	          })
	        ),
	        _react2.default.createElement(
	          OptionContainer,
	          {
	            id: 'opt-cont-2',
	            onMouseLeave: this.handleMouseLeave },
	          _react2.default.createElement(
	            FilterOption,
	            { onClick: this.handleOption },
	            'any'
	          ),
	          _react2.default.createElement(
	            FilterOption,
	            { onClick: this.handleOption },
	            'front-end'
	          ),
	          _react2.default.createElement(
	            FilterOption,
	            { onClick: this.handleOption },
	            'back-end'
	          ),
	          _react2.default.createElement(
	            FilterOption,
	            { onClick: this.handleOption },
	            'full-stack'
	          ),
	          _react2.default.createElement(
	            FilterOption,
	            { onClick: this.handleOption },
	            'santa claus'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        StyledFilter,
	        null,
	        _react2.default.createElement(
	          FilterTitle,
	          null,
	          'level'
	        ),
	        _react2.default.createElement(
	          FilterName,
	          { id: 'filter3', onClick: this.handleClick },
	          _react2.default.createElement(
	            'span',
	            null,
	            this.props.titles[2]
	          ),
	          _react2.default.createElement(_Icon2.default, {
	            icon: _constants.ICONS.CIRCLEDOWN,
	            size: 24,
	            color: function color(_ref3) {
	              var theme = _ref3.theme;
	              return theme.white;
	            }
	          })
	        ),
	        _react2.default.createElement(
	          OptionContainer,
	          {
	            id: 'opt-cont-3',
	            onMouseLeave: this.handleMouseLeave },
	          _react2.default.createElement(
	            FilterOption,
	            { onClick: this.handleOption },
	            'any'
	          ),
	          _react2.default.createElement(
	            FilterOption,
	            { onClick: this.handleOption },
	            'junior'
	          ),
	          _react2.default.createElement(
	            FilterOption,
	            { onClick: this.handleOption },
	            'middle'
	          ),
	          _react2.default.createElement(
	            FilterOption,
	            { onClick: this.handleOption },
	            'senior'
	          ),
	          _react2.default.createElement(
	            FilterOption,
	            { onClick: this.handleOption },
	            'wizard'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        StyledFilter,
	        null,
	        _react2.default.createElement(
	          FilterTitle,
	          null,
	          'location'
	        ),
	        _react2.default.createElement(
	          FilterName,
	          { id: 'filter4', onClick: this.handleClick },
	          _react2.default.createElement(
	            'span',
	            null,
	            this.props.titles[3]
	          ),
	          _react2.default.createElement(_Icon2.default, {
	            icon: _constants.ICONS.CIRCLEDOWN,
	            size: 24,
	            color: function color(_ref4) {
	              var theme = _ref4.theme;
	              return theme.white;
	            }
	          })
	        ),
	        _react2.default.createElement(
	          OptionContainer,
	          {
	            id: 'opt-cont-4',
	            onMouseLeave: this.handleMouseLeave },
	          _react2.default.createElement(
	            FilterOption,
	            { onClick: this.handleOption },
	            'any'
	          ),
	          _react2.default.createElement(
	            FilterOption,
	            { onClick: this.handleOption },
	            'my city'
	          ),
	          _react2.default.createElement(
	            FilterOption,
	            { onClick: this.handleOption },
	            'my country'
	          ),
	          _react2.default.createElement(
	            FilterOption,
	            { onClick: this.handleOption },
	            'earth'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        SubmitButton,
	        {
	          color: this.props.theme.primary.light,
	          type: 'submit',
	          onClick: this.handleSubmit },
	        'Submit'
	      )
	    );
	  };
	
	  return JobsFilter;
	}(_react2.default.Component);
	
	JobsFilter.propTypes = {
	  titles: _propTypes2.default.array.isRequired,
	  onChange: _propTypes2.default.func.isRequired,
	  onSubmit: _propTypes2.default.func.isRequired,
	  theme: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.object])
	};
	
	exports.default = (0, _styledComponents.withTheme)(JobsFilter);
	module.exports = exports['default'];

/***/ }),

/***/ 96:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  color: ', ';\n  margin: 0.2rem 0.2rem 0.2rem 0;\n  padding: 0.2rem 0.2rem 0.2rem 0;\n  ', ' ', ';\n'], ['\n  color: ', ';\n  margin: 0.2rem 0.2rem 0.2rem 0;\n  padding: 0.2rem 0.2rem 0.2rem 0;\n  ', ' ', ';\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n    font-size: 1.2rem;\n  '], ['\n    font-size: 1.2rem;\n  ']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n    font-size: 1rem;\n  '], ['\n    font-size: 1rem;\n  ']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n    justify-content: flex-start;\n  '], ['\n    justify-content: flex-start;\n  ']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  font-weight: 600;\n  font-size: 1rem;\n  color: ', ';\n  text-transform: capitalize;\n  margin: 0.2rem 0.2rem 0.2rem 0;\n  padding: 0.2rem 0.2rem 0.2rem 0;\n  ', ';\n  ', ';\n'], ['\n  font-weight: 600;\n  font-size: 1rem;\n  color: ', ';\n  text-transform: capitalize;\n  margin: 0.2rem 0.2rem 0.2rem 0;\n  padding: 0.2rem 0.2rem 0.2rem 0;\n  ', ';\n  ', ';\n']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n    font-size: 0.8rem;\n  '], ['\n    font-size: 0.8rem;\n  ']),
	    _templateObject7 = _taggedTemplateLiteralLoose(['\n    flex: 1 0 50%;\n  '], ['\n    flex: 1 0 50%;\n  ']),
	    _templateObject8 = _taggedTemplateLiteralLoose(['\n  font-size: 1.1rem;\n  color: ', ';\n  margin: 0.2rem 0.2rem 0.2rem 0;\n  padding: 0.2rem 0.2rem 0.2rem 0;\n  ', ';\n'], ['\n  font-size: 1.1rem;\n  color: ', ';\n  margin: 0.2rem 0.2rem 0.2rem 0;\n  padding: 0.2rem 0.2rem 0.2rem 0;\n  ', ';\n']),
	    _templateObject9 = _taggedTemplateLiteralLoose(['\n    font-size: 0.95rem;\n  '], ['\n    font-size: 0.95rem;\n  ']);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyLink = __webpack_require__(26);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _globalStyle = __webpack_require__(6);
	
	var _Quote = __webpack_require__(97);
	
	var _Quote2 = _interopRequireDefault(_Quote);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Wrapper = _styledComponents2.default.div.withConfig({
	  displayName: 'JobsList__Wrapper'
	})(['background:', ';border-radius:4px;border:1px solid ', ';margin:0.5rem 0;padding:0.5rem 0.5rem 0.5rem 0.7rem;'], function (props) {
	  return props.theme.white;
	}, function (props) {
	  return props.theme.primary.light;
	});
	
	var JobLink = (0, _styledComponents2.default)(_gatsbyLink2.default).attrs({
	  color: function color(props) {
	    return props.theme.secondary.red;
	  }
	}).withConfig({
	  displayName: 'JobsList__JobLink'
	})(['color:inherit;&:visited,&:active{color:inherit;}&:hover{color:', ';}'], function (props) {
	  return props.color;
	});
	var JobLi = _styledComponents2.default.div.withConfig({
	  displayName: 'JobsList__JobLi'
	})(['color:', ';margin:0rem;padding:0rem;'], function (props) {
	  return props.theme.primary.light;
	});
	
	var JobTitle = _globalStyle.StyledH3.extend(_templateObject, function (props) {
	  return props.theme.primary.light;
	}, _globalStyle.media.desktop(_templateObject2), _globalStyle.media.tablet(_templateObject3));
	var Items = _styledComponents2.default.div.withConfig({
	  displayName: 'JobsList__Items'
	})(['display:flex;flex-wrap:wrap;justify-content:space-between;', ';'], _globalStyle.media.phone(_templateObject4));
	
	var JobItem = _globalStyle.StyledP.extend(_templateObject5, function (props) {
	  return props.theme.text;
	}, _globalStyle.media.tablet(_templateObject6), _globalStyle.media.phone(_templateObject7));
	
	var JobText = _globalStyle.StyledP.extend(_templateObject8, function (props) {
	  return props.theme.text;
	}, _globalStyle.media.tablet(_templateObject9));
	
	var JobsList = function (_React$Component) {
	  _inherits(JobsList, _React$Component);
	
	  function JobsList() {
	    _classCallCheck(this, JobsList);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  JobsList.prototype.render = function render() {
	    return _react2.default.createElement(
	      Wrapper,
	      { area: this.props.area },
	      this.props.type === 'list' ? _react2.default.createElement(
	        JobLi,
	        null,
	        _react2.default.createElement(
	          JobTitle,
	          null,
	          _react2.default.createElement(
	            JobLink,
	            { to: '/' },
	            this.props.title
	          )
	        ),
	        _react2.default.createElement(_Quote2.default, null),
	        _react2.default.createElement(
	          Items,
	          null,
	          _react2.default.createElement(
	            JobItem,
	            null,
	            'Starting date: ' + this.props.text.date
	          ),
	          _react2.default.createElement(
	            JobItem,
	            null,
	            'Duration: ' + this.props.text.period
	          ),
	          _react2.default.createElement(
	            JobItem,
	            null,
	            'Level: ' + this.props.text.level
	          ),
	          _react2.default.createElement(
	            JobItem,
	            null,
	            'Topic: ' + this.props.text.topic
	          )
	        ),
	        _react2.default.createElement(
	          JobText,
	          null,
	          this.props.text.description
	        )
	      ) : _react2.default.createElement(
	        JobLi,
	        null,
	        _react2.default.createElement(
	          JobTitle,
	          null,
	          _react2.default.createElement(
	            JobLink,
	            { to: '/' },
	            this.props.title
	          )
	        ),
	        _react2.default.createElement(_Quote2.default, null),
	        _react2.default.createElement(
	          Items,
	          null,
	          _react2.default.createElement(
	            JobItem,
	            null,
	            'Type: ' + this.props.text.type
	          ),
	          _react2.default.createElement(
	            JobItem,
	            null,
	            'Role: ' + this.props.text.role
	          ),
	          _react2.default.createElement(
	            JobItem,
	            null,
	            'Level: ' + this.props.text.level
	          ),
	          _react2.default.createElement(
	            JobItem,
	            null,
	            'Location: ' + this.props.text.location
	          )
	        ),
	        _react2.default.createElement(
	          JobText,
	          null,
	          this.props.text.description
	        )
	      )
	    );
	  };
	
	  return JobsList;
	}(_react2.default.Component);
	
	exports.default = JobsList;
	
	
	Wrapper.propTypes = {
	  area: _propTypes2.default.string.isRequired
	};
	
	JobsList.propTypes = {
	  title: _propTypes2.default.string.isRequired,
	  text: _propTypes2.default.object.isRequired,
	  type: _propTypes2.default.string,
	  area: _propTypes2.default.string.isRequired
	};
	module.exports = exports['default'];

/***/ }),

/***/ 97:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    margin: 0.8rem 0;\n  '], ['\n    margin: 0.8rem 0;\n  ']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n    margin: 0.6rem 0;\n  '], ['\n    margin: 0.6rem 0;\n  ']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n    margin: 0.4rem 0;\n  '], ['\n    margin: 0.4rem 0;\n  ']);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _globalStyle = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var QuoteText = _styledComponents2.default.blockquote.withConfig({
	  displayName: 'Quote__QuoteText'
	})(['color:', ';font-size:1.5rem;margin:0.75rem 0 0;font-style:italic;'], function (props) {
	  return props.theme.primary.dark;
	});
	
	var Separator = _styledComponents2.default.hr.withConfig({
	  displayName: 'Quote__Separator'
	})(['height:5px;width:40px;background:', ';margin-left:0;border:none;'], function (props) {
	  return props.theme.primary.dark;
	});
	
	var Wrapper = _styledComponents2.default.div.withConfig({
	  displayName: 'Quote__Wrapper'
	})(['margin:1rem 0;', ' ', ' ', ';'], _globalStyle.media.giant(_templateObject), _globalStyle.media.desktop(_templateObject2), _globalStyle.media.tablet(_templateObject3));
	
	var Quote = function Quote(props) {
	  return _react2.default.createElement(
	    Wrapper,
	    null,
	    _react2.default.createElement(Separator, null),
	    _react2.default.createElement(
	      QuoteText,
	      null,
	      props.children
	    )
	  );
	};
	
	exports.default = Quote;
	
	
	Quote.propTypes = {
	  children: _propTypes2.default.string
	};
	module.exports = exports['default'];

/***/ }),

/***/ 248:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Hero = __webpack_require__(29);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	var _JobsContainer = __webpack_require__(241);
	
	var _JobsContainer2 = _interopRequireDefault(_JobsContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var JobsPage = function JobsPage(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_Hero2.default, { type: 'jobs' }),
	    _react2.default.createElement(_JobsContainer2.default, {
	      menuFilter: data.site.siteMetadata.filterOptions.jobs
	    })
	  );
	};
	
	var query = exports.query = '** extracted graphql fragment **';
	
	exports.default = JobsPage;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-jobs-js-40ae3fcf1917ba81959c.js